module.exports = __webpack_public_path__ + "static/img/68081E_5_R_20200731_LC.e9b4e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081E_5_R_20200731_LC.png
// module id = wWHE
// module chunks = 0